import lodgingCancellationPolicyGraphQl from '../api/lodgingCancellationPolicyGraphQl';
import listingExtendedActions from '../actions/lodgingCancellationPolicyActions';

async function updateIfDateChanged(store, action = {payload: {}}) {
    const {
        listingReducer: {unitApiUrl: unitUrl},
        systemReducer: {locale}
    } = store.getState();
    const {fieldsChanged, isInitialPageLoad} = action.payload;

    /* since  */
    if (!isInitialPageLoad && fieldsChanged.arriveDateText) {
        const data = await lodgingCancellationPolicyGraphQl({
            arrivalDate: fieldsChanged.arriveDateText,
            locale,
            unitUrl
        });

        if (data && data.houseRules) {
            store.dispatch(
                listingExtendedActions.updateLodgingCancellationPolicy(
                    data.houseRules.lodgingCancellationPolicy
                )
            );
        } else {
            store.dispatch(listingExtendedActions.updateLodgingCancellationPolicy(null));
        }
    }
}

export default updateIfDateChanged;
